/**
 * Created by odeds on 12/29/15.
 */
define(function (require) {
    "use strict";
    var BaseGallery = require("ui/gallery/gallery");
    var ApiKeysGalleryItemView = require("ui.components/gallery/js/views/ApiKeysGalleryItemView");
    var LE = require("app");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");

    var ApiKeysGallery = BaseGallery.extend({

        itemView: ApiKeysGalleryItemView,

        initialize:function (options) {
            BaseGallery.prototype.initialize.call(this, options);
        },

        /**
         * Override _getActionMenuOptions to ensure create button is always enabled
         * Removing restriction that was blocking API key creation after OAuth2 bot migration
         */
        _getActionMenuOptions: function () {
            var menuOptions = [
                { id:'create', "actionName":LE.translator.translate("LEFramework.global.captions.add"), "enabled":true}
            ];
            if(this.allowApiBasedWindow){
                menuOptions.push({ id:'addApiBasedWindow', "actionName":LE.translator.translate("LEFramework.gallery.actions.addApiBasedWindow"), "enabled":true});
            }
            menuOptions.push({ id:'edit', "actionName":LE.translator.translate("LEFramework.global.captions.edit"), "enabled":true});
            menuOptions.push({ id:'delete', "actionName":LE.translator.translate("LEFramework.global.captions.delete"), "enabled":true, "align":"right"});
            if(this.allowDuplicate){
                menuOptions.push({ id:'duplicate', "actionName":LE.translator.translate("LEFramework.global.captions.duplicate"), "enabled":true});
            }
            if(this.allowSetAsDefault){
                menuOptions.push({ id:'setAsDefault', "actionName":LE.translator.translate("LEFramework.global.captions.setAsDefault"), "enabled":true});
            }
            this.dropdownMenuOptionsItems = new DropdownMenu.Collection(menuOptions);

            return {
                name      : LE.translator.translate("LEFramework.global.captions.action"),
                el        : this.ui.actionMenuContainer,
                collection: this.dropdownMenuOptionsItems,
                tabindex  : "0",
                align: DropdownMenu.ALIGN.RIGHT
            };
        },

        /**
         * Override _toggleDropdownItems to ensure create button remains enabled
         * Prevents any code from disabling the create button
         */
        _toggleDropdownItems: function(itemModel) {
            // Call parent implementation if it exists
            if (BaseGallery.prototype._toggleDropdownItems) {
                BaseGallery.prototype._toggleDropdownItems.call(this, itemModel);
            }
            
            // Ensure create button is always enabled
            if (this.dropdownMenuOptionsItems) {
                var createMenuOption = this.dropdownMenuOptionsItems.findWhere({id : "create"});
                if (createMenuOption) {
                    createMenuOption.set("enabled", true);
                }
            }
        }

    });

    return ApiKeysGallery;
});
